import { Button } from "@material-ui/core";
import {
    green,
    deepPurple,
    deepOrange,
    indigo,
} from "@material-ui/core/colors";
const dataFilter = [
    {
        title: "Тарифы по порядку - не актив",
        color: indigo[500],
    },
    {
        title: "Тарифы по порядку",
        color: deepPurple[500],
    },
    {
        title: "Тарифы по именам",
        color: green[500],
    },
    {
        title: "Тарифы скрыты",
        color: deepOrange[500],
    },
];

export const ButtonFilterTarif = ({
    setStatusActualRatesFilter,
    statusActualRatesFilter,
    filterTarif,
}) => {
    console.log(
        "### dataFilter[statusActualRatesFilter].color, ",
        statusActualRatesFilter,
    );
    const switchStatus = () => {
        if (statusActualRatesFilter < 3) {
            setStatusActualRatesFilter(
                () => Number(statusActualRatesFilter) + 1,
            );
            localStorage.setItem(
                "localStorageStatusFilter",
                Number(statusActualRatesFilter) + 1,
            );
        } else {
            setStatusActualRatesFilter(() => 0);
            localStorage.setItem("localStorageStatusFilter", 0);
        }
    };

    return (
        <Button
            variant="contained"
            style={{
                backgroundColor: dataFilter[statusActualRatesFilter].color,
                color: "white",
            }}
            className={filterTarif}
            onClick={() => switchStatus()}
        >
            {dataFilter[statusActualRatesFilter].title}
        </Button>
    );
};
